import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { AssessmentTemplateListRow } from '@ts-assessments/interfaces'
import type { AssessmentTemplatesStore } from './interfaces'

import { isFullArray } from '@helpers/array'

const getMeta = (state: AssessmentTemplatesStore): Meta | null => state.templatesPaginatedData?.meta || null
const getTemplates = (state: AssessmentTemplatesStore): AssessmentTemplateListRow[] => state.templatesPaginatedData?.templates || []

export const getters = {
  isLoading: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['loading'] => state.loading,
  getTemplates: (state: AssessmentTemplatesStore): AssessmentTemplateListRow[] => getTemplates(state),
  hasTemplates: (state: AssessmentTemplatesStore): boolean => isFullArray(getTemplates(state)),
  getFilterSearch: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['filterSearch'] => state.filterSearch,
  getFilterType: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['filterType'] => state.filterType,
  getFilterDisciplineCode: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['filterDisciplineCode'] => state.filterDisciplineCode,
  getFilterGrade: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['filterGrade'] => state.filterGrade,
  getFilterStatus: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['filterStatus'] => state.filterStatus,
  hasFilters: (state: AssessmentTemplatesStore): boolean =>
    state.filterSearch !== null
    || state.filterType !== null
    || state.filterDisciplineCode !== null
    || state.filterGrade !== null
    || state.filterStatus !== null,
  getMeta: (state: AssessmentTemplatesStore): Meta | null => getMeta(state),
  /** Requested page — the request state, not what the last response reported. */
  getCurrentPage: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['currentPage'] => state.currentPage,
  getPerPage: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['perPage'] => state.perPage,
  getLastPage: (state: AssessmentTemplatesStore): number => getMeta(state)?.last_page || 1,
  getTotal: (state: AssessmentTemplatesStore): number => getMeta(state)?.total || 0,
  // No `isModalCreate` getter — the state field of that name is already readable on the store, and a
  // getter would collide with it (mirrors the `api-tokens` store).
  isModalDelete: (state: AssessmentTemplatesStore): boolean => state.templateToDelete !== null,
  isModalDuplicate: (state: AssessmentTemplatesStore): boolean => state.templateToDuplicate !== null,
  getTemplateToDelete: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['templateToDelete'] => state.templateToDelete,
  getTemplateToDuplicate: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['templateToDuplicate'] => state.templateToDuplicate,
  getDeleteBlockedAssessmentsCount: (state: AssessmentTemplatesStore): AssessmentTemplatesStore['deleteBlockedAssessmentsCount'] => state.deleteBlockedAssessmentsCount,
  /** The last delete attempt hit the 409 guard — the modal offers *duplicate* instead. */
  isDeleteBlocked: (state: AssessmentTemplatesStore): boolean => state.deleteBlockedAssessmentsCount !== null,
}
